export enum PriceOperations {
    GET_PRICE_DETAILS = 'GET_PRICE_DETAILS'
}